import { useCallback } from 'react';
import _ from 'lodash';

export default function useDebounceWithCallback(
  funcToDebounce = () => {},
  timeoutSize = 1500,
  depArray,
) {
  return useCallback(_.debounce(funcToDebounce, timeoutSize), depArray);
}
